<template>
  <div class="root-container">
    <van-nav-bar
      title="快捷通服务协议"
      left-text="返回"
      left-arrow
      safe-area-inset-top
      fixed
      style="padding-top: 20px"
      @click-left="$router.go(-1)"
    />
    <div style="padding: 12px; margin-top: 60px">
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >本《快捷通服务协议》（以下简称“本协议”）是由您与快捷通支付服务有限公司（以下简称“本公司”）签订的关于使用快捷通互联网支付服务（以下简称“本服务”）的法律协议。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >为保障您的合法权益，请于注册成为快捷通用户前，仔细阅读本协议所有内容，尤其注意以</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >粗体格式标注</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">的内容。</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >当您注册或使用本服务时，即表示您已充分阅读、理解并同意接受本协议之所有内容。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >本协议内容同时包括</span
        ><a
          href="https://sc-static.kjtpay.com/wallet/agreement/secret.html"
          style="text-decoration: none"
          referrerpolicy="no-referrer"
          ><span
            style="font-family: 微软雅黑; font-weight: bold; color: #0085f6"
            >《隐私保护声明》</span
          ></a
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >,且您在使用快捷通某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何单独协议的接受，即视为您对本协议全部的接受。您对本协议的接受，即视为您对</span
        ><a
          href="https://sc-static.kjtpay.com/wallet/agreement/secret.html"
          style="text-decoration: none"
          referrerpolicy="no-referrer"
          ><span
            style="font-family: 微软雅黑; font-weight: bold; color: #0085f6"
            >《隐私保护声明》</span
          ></a
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >的接受。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >本公司保留随时修改本协议之权利，并将于前述修改生效前30日通过快捷通网站（www.kjtpay.com）（以下简称“本网站”）公布最新变更事项，而无需另作个别通知。若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容；若您不同意修改后的协议内容，您应立即停止使用本服务。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
          -aw-import: list-item;
          -aw-list-level-number: 0;
          -aw-list-number-format: '%0、';
          -aw-list-number-styles: 'chineseCounting';
          -aw-list-number-values: '1';
        "
      >
        <span style="-aw-import: ignore"
          ><span style="font-family: 微软雅黑; color: #4e4e4e">一、</span></span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">声明与承诺</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)您保证，</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >您是具有完全民事行为能力的自然人或是依法成立的企业、机关事业单位或者其他组织</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >，您是根据自身意愿注册快捷通账户成为本网站的用户，您的注册并不存在任何被欺诈或被胁迫。您注册所使用的信息为您本人或企业信息，不存在盗用、冒用他人身份或干扰他人使用本服务的行为。若您为无民事行为能力人或为限制民事行为能力人，您应立即终止注册或停止使用快捷通服务。若您非自然人，则您确认，在您取得快捷通账户时，或您以其他本公司允许的方式实际使用快捷通服务时，您为在中国大陆地区合法设立并开展经营活动或其他业务的法人或其他组织，且您订立并履行本协议不受您所属、所居住或开展经营活动或其他业务的国家或地区法律法规的排斥。不具备前述条件的，您应立即终止注册或停止使用快捷通服务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)您了解并同意，注册快捷通账户是您使用本服务的必要但非全部条件。本公司有权依据其相关规定及自身独立判断，决定是否接受您成为快捷通的用户。若您为非自然人用户，</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >您可能需要同本公司另行签订纸质服务协议</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)您了解并同意，本公司并非金融机构，本服务非金融业务，</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >所有通过和使用本服务进行流转、存放、提现的资金，在任何情况下均不产生任何形式的利息</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >，如上述资金在使用本服务期间发生贬值，其风险由您自行承担。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)您了解并同意，</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >快捷通账户所记录的资金余额不同于您本人的银行存款，不受《存款保险条例》保护，其实质为客户委托支付机构（即本公司）保管的、所有权归属于客户的预付价值。该预付价值对应的货币资金虽然属于客户，但不以客户本人名义存放在银行，而是以支付机构名义存放在银行，并且由支付机构向银行发起资金调拨指令</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五)您同意，如本公司需要对本协议进行变更或修改的，须通过www.kjtpay.com网站公告的方式提前予以公布，公告期限届满后即时生效；若您在本协议内容公告变更生效后继续使用快捷通服务的，表示您已充分阅读、理解并接受变更后的协议内容，也将遵循变更后的协议内容使用快捷通服务；若您不同意变更后的协议内容，您应在变更生效前停止使用快捷通服务。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">二、服务条款</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)充值：您可以利用银行转账等方式向您自身的快捷通帐户汇入一定金额的款项。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)付款：您可以利用本服务向其他快捷通用户支付各类款项。您同意本公司将与银行、第三方支付机构合作，共同完成有关付款服务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)收款：您可以利用本服务代为收取其他快捷通用户向您支付的各类款项。您同意本公司将与银行、第三方支付机构合作，共同完成有关收款服务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)提现：您可以要求本公司将您快捷通账户内的资金提出到您的银行账户中，该银行账户应该是同您认证的信息严格一致的有效的中国大陆银行账户。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五)查询：您可以查询您的快捷通账户内的交易信息，快捷通为您提供最近一年的交易记录的免费查询服务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(六)退回：当您使用本服务进行付款时，可能由于您提供的账户信息有误、银行方面原因或其他因素造成交易无法完成，此时本公司将在确认后将付款金额按原支付路径退回至您的快捷通账户或银行卡账户中。</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(七)交易风险：若您或对方未遵守本协议或本网站提示的操作步骤或规定条件（包含任何不合法或未经许可之交易），本公司不承诺交易会顺利或者正确完成，且本公司不承担任何责任。若在上述情形下相关款项已先行划入您的快捷通账户的，本公司有权且无需附加任何条件而向您取回该款项。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(八)客户服务：若您对快捷通提供的服务有疑问或不满时，你可通过快捷通官方网站（www.kjtpay.com）客服中心内提供的联系方式（客服热线：400-611-0909，客服邮箱：service@kjtpay.com，在线客服：直接在网站中点击图标即可）与快捷通的客服人员联系。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >以上服务的具体业务流程，您可在</span
        ><span style="text-decoration: none"
          ><span style="font-family: 微软雅黑; color: #4e4e4e"
            >网站帮助中心及公告</span
          ></span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >中获取，请您依据需求查阅。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >三、您的权利与义务</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          您应当以您真实有效的电子邮箱地址或手机号码作为用户名，该用户名是您区别于本网站其他用户的唯一编号，并且</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >您应当自行设置、并妥善保管快捷通账户密码。快捷通账户密码分为登录密码与交易密码，您在快捷通登录页面登录您的快捷通账户时须输入登录密码，当您的快捷通账户与其他账户（包括您的或者其他人的银行账户与快捷通账户）发生交易时时，依不同的支付方式，在您选择快捷支付时，您须输入您的支付密码及手机验证码；在您选择网银交易时，您应依照相关银行的要求的方式进行交易验证，否则将无法交易。为更好的保障您的资金安全，快捷通为您提供了数字证书及快捷盾的服务，请您依快捷通要求进行操作</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)
          您有义务在对快捷通账户进行注册、实名认证或挂失等情形下，按照本网站提示提供您的最新、真实、有效且完整的资料，并有义务维护并立即更新您的资料（包括但不限于姓名、名称、地址等一切注册与实名认证等之必要信息）。</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >因您未及时更新资料导致的一切后果，均应由您自行承担，该后果包括但不限于导致本服务无法提供或提供时发生任何错误、快捷通账户及该账户内余额被别人盗用，且您不得将此作为取消交易、拒绝付款的理由。</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >(三)
          您了解并同意，本公司有权核验您的身份信息与银行账户信息的真实性，且当本公司有合理理由怀疑或确认您提供的资料错误、不实、过时或不完整的，本公司有权要求您在指定期间提供指定资料，并有权视情形采取限制交易额度、暂停部分服务或终止您的快捷通账户等措施，且不承担由此产生的一切损失。</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >(四) 若您为个人用户, 您确认,
          本公司有权在出现下列情形时要求核对您的有效身份证件或其他必要文件,
          留存有效身份证件的彩色扫描件,
          且完成本公司要求的相关身份认证。您应积极配合，否则本公司有权限制或停止向您提供部分或全部快捷通账户服务：</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >A.
          您办理充值、收取或支付单笔金额人民币1万元以上或者外币等值1000美元以上业务的；</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >B. 您全部快捷通账户30天内充值、收取及支付总金额累计人民币5
          万元以上或外币等值1万美元以上的；</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >C.
          您全部快捷通账户余额连续10天超过人民币5000元或外币等值1000美元的；</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >D.您使用快捷通服务买卖金融产品或服务的；</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >E.您要求变更身份信息或您身份信息已过有效期的；</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >F.本公司认为您的交易行为或交易情况出现异常的；</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >J.本公司认为您的身份资料存在疑点或本公司在向您提供服务的过程中认为您已经提供的身份信息或相关资料存在疑点的；</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >H.本公司认为应核对或留存您身份证件或其他必要文件的其他情形的。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五)
          您应当保证您发起的交易有真实的交易背景，不得进行虚假交易；您应保证您利用本服务进行的所有活动均合法合规且符合本合同之约定。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(六) 您的快捷通账户</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >不可转让、不可赠与、不可继承，您不得将支付账户用于本协议约定范围以外的其他用途，也不得出租、转让给任何第三方使用</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >。当您的快捷通账户需要终止时，您应及时将该快捷通账户下的余额全部提现。您同意，若您丧失全部或部分民事权利能力或民事行为能力，本公司有权根据有效法律文书处置与您的快捷通账户有关款项。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(七)
          您同意本公司通过您的注册电子邮箱或注册手机号码等方式向您发送通知。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(八)
          您应保证您的连线设备具备良好的性能与状态。若因您的连线设备损坏或故障，造成您与本服务连接时所进行的交易和提现记录丢失的，本公司将不承担您因此遭受的任何损失。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(九)
          您不得采取反向工程等手段对快捷通支付服务系统和程序进行破解，不得对上述系统和程序（包括但不限于源程序、目标程序、软件文档、运行在本地电脑内存中的数据）进行复制、修改、编译、整合和篡改，不得修改或增加乙方支付服务系统的原有功能。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(十)
          您在使用快捷通支付服务的过程中有权获取快捷通相关的技术和服务支持，若您对快捷通提供的支付服务有任何不满的，有权进行反馈或投诉，快捷通将依据相应的处理流程及规则进行处理。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">(十一)</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >您了解并同意，您同意本协议即意味着您授权快捷通向您的银行账户发起支付指令扣划资金</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >四、本公司的权利与义务</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          本公司有权就本服务向您收取相应服务费用，并有权制定及调整服务费标准，具体服务费用以本网站公示标准及您与本公司签订的纸质支付服务协议为准。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)
          本公司有权自行决定对本公司系统与服务进行改动和升级。本公司有权根据系统升级等需要暂时中止提供本服务，但一般应提前五个工作日在本公司网站显著位置公示，并预告恢复日期。因银行、电信、电力供应或不可抗力等原因造成本服务突发性中止的，提前公示期限不受前述约束。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)
          任何情况下，您的资金始终独立于本公司资金之外，本公司不会将您的资金用于非您指示的用途上。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)
          本公司负责本服务平台的建设、运营和管理，并有权制订和修改相应的管理规则，并有权依据相关法律及服务平台管理规则对您的快捷通账户的功能，交易的额度、频次等进行设置。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五)
          本公司有义务接受和处理因本服务系统本身出现问题而产生的投诉和纠纷，但不参与您与第三方之间的具体交易过程，也不对您与第三方之间的纠纷承担责任。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(六)
          本公司对您通过快捷通平台并使用安全产品、密码、电子签名进行的支付指令提供专业的服务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">(七)</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >您同意本公司基于自身之独立判断，在发现以下情形时，有权要求您在指定期间提供相关信息资料等，并有权不经通知先行对您的快捷通账户采取限制交易额度或次数、暂缓账户内资金结算、暂停部分服务或终止等措施，本公司不承担因此造成的任何损失：</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >1、您存在高风险交易、异常交易、可疑交易或违法交易的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >2、您涉嫌违反本协议约定或精神的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >3、银行、银联或有关国家监管部门等的合法指示和要求；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >但是上述风险判断与控制并不构成本公司对您的一项义务或责任。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(八)
          如果您有以下情形之一的，本公司有权立即终止本协议，并有权追偿因此情形导致的全部损失，</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >如涉嫌犯罪，本公司有权移交公安机关处理：</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >1、反对宪法所确定的基本信息服务；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >2、危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >3、损坏国家荣誉和利益的；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >4、煽动民族仇恨、民族岐视、破坏民族团结的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >5、破坏国家民族宗教政策，宣扬邪教和封建迷信的；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >6、散布谣言，扰乱社会秩序，破坏社会稳定的；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >7、散布谣言、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >8、侮辱或者诽谤他人，侵害他人合法权益的；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >9、经营网站含有法律、行政法规禁止的其他内容的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >10、从事伪造或是偷窃物品之交易；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >11、从事任何与赌博性商品或行为有关之交易；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >12、侵害第三者之著作权、专利权、知识财产权、商标或商业机密之交易；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >13、从事洗钱、套现、恐怖融资、诈骗等任何违法之行为；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >14、从事任何有关色情交易；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >15、从事任何可能含有电脑病毒或是任何可能侵害本服务系统、功能、资料之行为；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >16、任何可能对本服务造成部份或全部妨害之行为；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >17、不履行相关义务导致本协议不能履行或不能实际履行；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >18、故意诋毁或损害本公司的声誉；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >19、因各种原因导致无法继续经营、停业、或进入破产清算程序的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >20、协议有效期内发生的其他严重违反本协议约定的行为；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >21、从事任何违反中华人民共和国相关法律，法规和规定的不正当交易；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >22、违反法律法规规定的其他情形。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(九)
          本公司已建立风险准备金制度和交易赔付制度，并将依据相关法规及实际情况逐步完善，本公司将依据上述制度规定承担风险损失赔付责任，以保证您的合法权益。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(十)
          若您的账户被公安机关认定并纳入电信网络新型违法犯罪交易风险事件管理平台“涉案账户”名单的，则本公司有权中止该账户所有业务并通知您重新核实身份，如您未在3日内向本公司重新核实身份的，则本公司有权暂停您的支付账户的所有业务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(十一)
          若您被公安机关认定为出租、出借、出售、购买银行账户或支付账户的单位和个人及相关组织者，假冒他人身份或者虚构代理关系开立银行账户或者支付账户的单位和个人，则本公司有权暂停您支付账户的所有业务5年，3年内不为您开立新账户。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(十二)
          若您为单位用户，且您被列入全国企业信用信息公示系统“严重违法失信企业名单”或经核实单位注册地址不存在或者虚构经营场所的，本公司有权拒绝为您开户或暂停您支付账户的业务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(十三)
          若您开立的支付账户自开户之日起6个月内无交易记录的，本公司有权暂停该账户的所有业务并要求您重新核实身份，待身份重新核实后，本公司可以恢复该账户的业务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(十四)对多人使用同一联系电话号码开立和使用账户的，若相关当事人无法证明其合理性的，本公司可暂停相关支付账户的所有业务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(十五)本公司有权拒绝为已被列入金融信用信息基础数据库——黑名单中单位及有相关个人担任法定代表人或者负责人的商户开立支付账户，提供支付服务，已开立支付账户及提供支付服务的，本公司有权自用户被列入黑名单之日起10日内予以清退。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">五、权利保证</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          本公司拥有“快捷通软件”及相关产品和服务的一切权利，包括但不限于：商标、文字、软件、声音、图片、录像、图表、广告中的全部内容、本公司电子邮件的全部内容、本网站全部内容等，所有这些内容均受法律的保护，未经本公司授权不得擅自使用，否则您将赔偿因此给本公司造成的全部损失。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)
          您应保证不侵犯任何第三方的知识产权等权益，如本公司因此而被任何第三方主张权利（无论基于何种形式），您应赔偿本公司遭受的全部损失。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">六、账户管理</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          您知悉并同意，本公司将根据监管法规的要求对快捷通账户进行分类管理，且本公司将根据下述分类管理的要求对快捷通账户功能进行限制：</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >1、如您是以非面对面方式通过至少一个合法安全的外部渠道进行身份基本信息验证，且是首次在本公司开立快捷通账户的个人客户，本公司将为您开立Ⅰ类账户，账户余额仅可用于消费和转账，余额付款交易自账户开立起累计不超过1000元[包括快捷通账户向您本人同名银行账户转账]；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >2、如您是以面对面方式核实身份的个人客户，或以非面对面方式通过至少三个合法安全的外部渠道进行身份基本信息多重交叉验证的个人客户，本公司将为其开立Ⅱ类账户，账户余额仅可用于消费和转账，其所有快捷通账户的余额付款交易年累计不超过10万元[不包括快捷通账户向您本人同名银行账户转账]；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >3、如您是以面对面方式核实身份的个人客户，或以非面对面方式通过至少五个合法安全的外部渠道进行身份基本信息多重交叉验证的个人客户，本公司将为您开立Ⅲ类账户，账户余额可以用于消费、转账以及购买投资理财等金融类产品，其所有快捷通账户的余额付款交易年累计不超过20万元[不包括快捷通账户向您本人同名银行账户转账]。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)
          本公司对您身份基本信息的外部验证渠道，包括但不限于政府部门数据库、商业银行信息系统、商业化数据库等。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)
          您在本公司只能开立一个Ⅲ类账户，若您已在本公司开立多个Ⅲ类账户的，则本公司将按您提供的联系方式与您联系并与您确认需保留的账户；若本公司按您提供的联系方式在相关法规指定的时间前无法联系到您时，本公司有权依您账户的使用情况，对使用频率较高和金额较大的账户予以保留，其余账户降低类别管理或予以撤并。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)
          若您为单位用户的，您的快捷通账户与他人快捷通账户之间的转账每日最高额度为2000万元人民币，每日不得超过10次；您的快捷通账户与他人银行账户之间转账每日最高额度为2000万元人民币，每日不得超过10次。但您与本公司另有约定的或您的开户行低于本标准的除外。本公司有权依据风险管理的要求（包括但不限于实名认证，交易情况等）对您的快捷通日累计转账额度及次数进行调整。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五)
          若您为个人用户的，本公司不提供转账到其他人快捷通账户及银行账户的服务。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >七、用户信息保护</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >（一）保护用户信息是快捷通的一项基本原则。快捷通将按照本协议及</span
        ><a
          style="text-decoration: none"
          href="https://sc-static.kjtpay.com/wallet/agreement/secret.html"
          referrerpolicy="no-referrer"
          ><span
            style="font-family: 微软雅黑; font-weight: bold; color: #0085f6"
            >《隐私保护声明》</span
          ></a
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >的规定收集、使用、储存和分享您的信息（包括但不限于您的姓名、性别、年龄、国籍、居住城市、通讯地址、邮政编码、电子邮件、手机号码、电话号码、身份证资料、交易流水记录、银行信用卡和银行来往账户的信息以及所需必要的身份证件号码、个人生物识别信息、银行帐号、通信内容、健康生理信息等个人敏感信息）。本协议对信息保护相关内容未作明确规定的，均应以</span
        ><a
          style="text-decoration: none"
          href="https://sc-static.kjtpay.com/wallet/agreement/secret.html"
          referrerpolicy="no-referrer"
          ><span
            style="font-family: 微软雅黑; font-weight: bold; color: #0085f6"
            >《隐私保护声明》</span
          ></a
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >的内容为准。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >（二）您在注册账户或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则可能无法使用本服务或在使用过程中受到限制。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >（三）快捷通将尽可能运用各种安全技术和程序建立完善的管理制度来保护您的信息，以免遭受未经授权的访问、使用或披露。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >八、服务费用及资金结算方式</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">(一)</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >在您使用本服务时，本公司有权依照您所使用的服务向您收取服务费用。本公司拥有制订及调整服务费之权利，具体服务费用以您使用本服务时本网站产品页面上所列之</span
        ><a
          style="text-decoration: none"
          href="https://static.kjtpay.com/wallet/help/rateSystem.html"
          referrerpolicy="no-referrer"
          ><span
            style="font-family: 微软雅黑; font-weight: bold; color: #0085f6"
            >收费方式公告</span
          ></a
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >或您与本公司达成的其他书面协议为准</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">(二)</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >除非另有说明或约定，您同意本公司有权自您委托本公司代收或代付的款项或您任一快捷通账户余额或者其他资产中直接扣除上述服务费用</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)
          本公司为您提供T+0、T+1等资金结算的方式，您可依需求在操作时自主选择本协议另有约定的除外。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)
          对于入网不满90日或者入网后连续正常交易不满30日用户，本公司有权拒绝提供T+0资金结算的服务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五)
          若支付交易存在误差，双方协商解决，无法协商一致的，以快捷通支付服务系统记录的为准；若与快捷通发生资金往来的银行系统记录与快捷通支付系统的记录不一致的，按快捷通与相应银行之间的协议约定处理。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">九、安全条款</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          您应妥善保管您的快捷通账户、密码和本公司提供的一切安全产品，并保证只在安全环境下由您本人使用您的快捷通账户，不向其他任何人透露或允许使用您的上述安全信息。</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >由于您的原因导致上述安全信息被他人知悉或使用，进而造成您的损失的，本公司不承担任何责任</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)
          当您发现您的快捷通账户、密码以及本公司提供的安全产品等泄露、遗失或被第三人冒用、盗用等其他任何未经合法授权的异常情形的，您应立即通知本公司，向本公司申请暂停相关服务，并按照本网站提示向本公司提交必要证明资料以便本公司及时确认。</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >在确认上述事实前，您的快捷通账户已发生的登录或交易结果均须由您独自承担</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >，除非可证明本公司对上述安全信息之泄露、遗失及未经合法授权之情形存在故意或重大过失。若您延迟通知或不按照本网站提示提交资料的，则本公司对延迟期间产生的损失不承担任何责任。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)
          如果您不小心泄漏了您的密码，请立即登录您的快捷通账户更改您的密码。设置的密码应方便您的记忆而不易破解，避免选择一些显而易见的词或者日期，比如：英文名字、出生日期、电话号码等。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)
          基于计算机端、手机端以及使用其他电子设备的差异性，我们可能在您使用具体产品时设置不同的账户登录模式及采取不同的措施识别您的身份。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五)
          尽量不要把您在其他网站的密码用在这里，在多个网站使用同一密码，会提高您输入同一密码的几率，这样您的密码就很容易被别人窃取。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(六)
          只有在浏览器的URL是以https://www.kjtpay.com/开头时，您才可在网页上输入密码。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(七)
          请审慎选择电子邮件中包含的链接，该链接可能会将您错误的导向一些网页，引诱您输入您的私人信息，请您特别小心。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">(八)</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >本公司不能也不会对因您未能遵守本协议约定而发生的任何损失及其他不利后果负责。您理解本公司对您的请求采取行动需要合理期限，在此之前，本公司对已执行的指令及(或)所导致的您的损失不承担任何责任</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">(九)</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >您知悉并同意，本公司有权跟进国家法律或和行政法规所赋予权力的有权机关及合作银行的要求对您的个人信息或对您的快捷通账户进行查询、暂缓结算或扣划</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >十、免责条款与赔偿范围</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          因不可抗力或本公司不能控制的原因导致您无法使用本服务或造成您损失的，本公司不承担任何责任，但将尽力减少因此给您造成的损失和影响。上述不可抗力与本公司不能控制的原因包括但不限于以下情形：</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >1、台风、地震、海啸、洪水、战争等。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >2、黑客攻击、计算机病毒侵入或发作；</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >3、计算机系统遭到破坏、瘫痪或无法正常使用而导致信息或记录的丢失等的；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >4、电信部门技术调整导致之重大影响；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >5、电信机线设备原因以致发生错误、迟滞中断或不能传递；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >6、因政府管制而造成的暂时性关闭等；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >7、出于您与交易相对方、银行、电信、网络、设备及供电故障等其他不可抗力或其他不可归责于本公司的事由。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">(二)</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >您了解并认可，您使用本服务将存在一定的风险，该等风险包括但不限于：您的快捷通账户和密码被他人冒用、盗用、或有其他任何未经合法授权之情形发生；或不法分子盗用您的银行卡；或对方拒绝付款等。这些风险均会给您造成经济损失，除非可证明本公司对损失的形成存在故意或重大过失，本公司将不承担任何责任</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e">。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)
          您同意，您使用本服务所存在的风险及后果将完全由您独自承担，本公司对您的交易行为及其影响不承担任何责任。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)
          本公司不保证本网站设置的外部链接的准确性和完整性，也不对该等外部链接指向的不由本公司实际控制的任何网页上的内容承担任何责任。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五) 本公司不对本服务提供任何形式的保证，包括但不限于以下事项：</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >1、本服务完全符合您的需求；</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span
        ><span style="font-family: 微软雅黑; color: #4e4e4e"
          >2、本服务不受干扰、及时提供或免于出错。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >十一、责任与承担</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          如果您违反有关法律、法规或本协议项下的任何条款而给本公司或任何第三方造成损失的，您应承担由此造成的损害赔偿责任。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)
          如果本公司违反本协议约定致使您的资料对外泄露的，本公司将赔偿您因此所造成的直接经济损失，并且将采取积极的办法做出补救；如果您违反本协议约定致使您或本网站其他用户的资料被他人获取、破坏、对外泄露的，应当赔偿本公司因此遭受的直接经济损失。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e"
          >十二、法律适用与管辖法院</span
        ><br /><span
          style="font-family: 微软雅黑; font-weight: bold; color: #4e4e4e"
          >本协议的订立、效力、解释、履行和争议的解决等均适用中华人民共和国法律，并应以本公司所在地有管辖权的人民法院为一审管辖法院。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-indent: 18pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">&#xa0;</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: left;
          line-height: 18pt;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-family: 微软雅黑; color: #4e4e4e">十三、其他事项</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(一)
          本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。除非经本公司书面同意，您无法转移任何权利和义务。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(二)
          不论本协议中的任何条款因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(三)
          本协议与纸质服务协议具有同等法律效力。如本协议与纸质服务协议约定不一致的，优先适用纸质服务协议的约定。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(四)
          若您在使用快捷通账户的同时还涉及到本公司的其它产品或服务的，您同时还须遵守本公司其它产品和服务的规定。</span
        ><br /><span style="font-family: 微软雅黑; color: #4e4e4e"
          >(五) 本协议所称“以上”,均包括本数。</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt">
        <span style="-aw-import: ignore">&#xa0;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt">
        <span style="font-family: 微软雅黑; font-weight: bold"
          >重要承诺：本人（单位）充分了解并清楚知晓出租、出借、出售、购买账户的相关法律责任和惩戒措施，承诺依法依规开立和使用本人（单位）账户。</span
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
};
</script>

<style lang="scss" scoped>
.root-container {
  font-size: 13px;
  background-color: white;
}
</style>